module.exports = __webpack_public_path__ + "img/structure.921be31e.png";